module.exports = __webpack_public_path__ + "images/psp/SizeGuide/updated/extra-large-10x30-300x2400.svg";